// import fetch from "cross-fetch"
import fetch from "isomorphic-fetch"
import { apolloClient } from "@vt-team/design-system-deprecated"

// export default apolloClient({ uri: "http://localhost:3000/api", fetch })
export default apolloClient({ uri: "https://api.vt.team/api", fetch })
